// src/ai/commandProcessor.js

import { getMetricFromCommand } from './helpers';
import * as Queries from './queryCommands';
import * as Actions from './actionCommands';

export const processCommand = async (command, customers, conversationState, setConversationState) => {
    // Eğer bir diyalog içindeysek, komutu diyalog işlemcisine yönlendir
    if (conversationState) {
        if (conversationState.command === 'create_pre_interview') {
            return await Actions.processPreInterviewConversation(command, conversationState, setConversationState);
        }
    }

    const metric = getMetricFromCommand(command);

    switch (metric) {
        // Sorgu (Query) Komutları
        case 'device_owner_lookup': return await Queries.handleDeviceOwnerLookup(command);
        case 'customer_phone_lookup': return await Queries.handleCustomerPhoneLookup(command, customers);
        case 'service_count_query': return await Queries.handleServiceCountQuery(command);
        case 'customer_balance': return await Queries.handleCustomerBalance(command, customers);
        case 'service_status': return await Queries.handleServiceStatus();
        case 'pre_interviews': return await Queries.handlePreInterviews();
        case 'daily_report': return await Queries.handleDailyReport(command);
        
        // Eylem (Action) Komutları
        case 'update_service_status': return await Actions.handleUpdateServiceStatus(command);
        case 'create_pre_interview': return Actions.handleCreatePreInterview(setConversationState);
        
        // Varsayılan Yanıt
        default: return "Bu komutu anlayamadım, lütfen farklı bir şekilde tekrar deneyin.";
    }
};